import { render } from "./language-select.vue?vue&type=template&id=5b56dfdc&scoped=true"
import script from "./language-select.vue?vue&type=script&lang=js"
export * from "./language-select.vue?vue&type=script&lang=js"

import "./language-select.vue?vue&type=style&index=0&id=5b56dfdc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b56dfdc"]])

export default __exports__